import React, { useState } from "react";
import Navbar from "../common-component/navbar/Navbar";
import "../downloadpage/DownloadPage.css";
import hayatlogo from "../../assets/home-images/right-section-images/hayatlogo.png";
import app_store from "../../assets/home-images/right-section-images/app_store.png";
import play_store from "../../assets/home-images/right-section-images/play_store.png";
import qr from "../../assets/home-images/right-section-images/qr.png";
import upload from "../../assets/offers/upload.png";

import instagram from "../../assets/downloadpage/instagram.png";
import facebook from "../../assets/downloadpage/facebook.png";
import tiktok from "../../assets/downloadpage/tiktok.png";
import youtube from "../../assets/downloadpage/youtube.png";
import linkedin from "../../assets/downloadpage/linkedin.png";

import slantarrow from "../../assets/downloadpage/slantarrow.png";

import hayatapp from "../../assets/downloadpage/hayatapp.png";
import hayatbusiness from "../../assets/downloadpage/hayatbusiness.png";
import explive from "../../assets/downloadpage/explive.png";
import grandm from "../../assets/downloadpage/grandm.png";
import ramadan from "../../assets/downloadpage/ramadan.png";

import goffer1 from "../../assets/downloadpage/goffer1.png";
import goffer2 from "../../assets/downloadpage/goffer2.png";
import goffer3 from "../../assets/downloadpage/goffer3.png";
import roffer1 from "../../assets/downloadpage/roffer1.png";
import roffer2 from "../../assets/downloadpage/roffer2.png";
import roffer3 from "../../assets/downloadpage/roffer3.png";

import businessicon from "../../assets/home-images/businessicon.jpg";


const DownloadPage = () => {
    const [activeTab, setActiveTab] = useState("Links");
    const [selectedSection, setSelectedSection] = useState(null); // null = all, "grandMillennium", "ramadanSpecials"

    return (
        <>
            <Navbar />

            <div className="downloadpage-middle-section-container">
                <div className="downloadpage-mid-div">
                    {/* Top Section */}
                    <div className="downloadpage-top-section">
                        <div className="downloadpage-upload-icon">
                            <img src={upload} alt="upload" />
                        </div>
                        <div className="downloadpage-logo-section">
                            <div className="downloadpage-logo">
                                <img src={hayatlogo} alt="Hayat In Logo" />
                            </div>
                            <h1 className="downloadpage-title">Hayat In App</h1>
                            <p className="downloadpage-tagline">
                                A space where people & businesses meet, grow & build together.
                            </p>
                            <div className="downloadpage-store-buttons-top">
                                <a
                                    href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={app_store} alt="Download on the App Store" />
                                </a>
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={play_store} alt="Get it on Google Play" />
                                </a>
                            </div>
                            <div className="downloadpage-social-icons">
                                <a
                                    href="https://www.instagram.com/hayatin.app/"
                                    className="social-icon instagram"
                                    aria-label="Instagram"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={instagram} className="instagram-img" alt="insta" />
                                </a>
                                <a
                                    href="https://www.facebook.com/profile.php?id=61575173424191"
                                    className="social-icon facebook"
                                    aria-label="Facebook"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={facebook} className="facebook-img" alt="insta" />
                                </a>
                                <a
                                    href="https://www.linkedin.com/company/hayatin/posts/?feedView=all"
                                    className="social-icon linkedin"
                                    aria-label="LinkedIn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={linkedin} className="linkedin-img" alt="insta" />
                                </a>
                                <a
                                    href="https://www.tiktok.com/@hayatinapp?is_from_webapp=1&sender_device=pc"
                                    className="social-icon tiktok"
                                    aria-label="TikTok"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={tiktok} className="tiktok-img" alt="insta" />
                                </a>
                                <a
                                    href="http://www.youtube.com/@HayatIn-e1p"
                                    className="social-icon youtube"
                                    aria-label="YouTube"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={youtube} className="youtube-img" alt="insta" />
                                </a>
                            </div>

                            <div className="downloadpage-tab-switcher">
                                <button
                                    className={`downloadpage-tab ${activeTab === "Links" ? "active" : ""}`}
                                    onClick={() => {
                                        setActiveTab("Links");
                                        setSelectedSection(null);
                                    }}
                                >
                                    Links
                                </button>
                                <button
                                    className={`downloadpage-tab ${activeTab === "Shop" ? "active" : ""}`}
                                    onClick={() => {
                                        setActiveTab("Shop");
                                        setSelectedSection(null); // Show all sections when clicking Shop tab directly
                                    }}
                                >
                                    Shop
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Middle Section - Conditional Content */}
                    {activeTab === "Links" ? (
                        <div className="downloadpage-blue-panel">
                            <a
                                href="https://hayatinapp.com/download"
                                className="downloadpage-interactive-item"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="downloadpage-item-icon blue">
                                    <img src={hayatapp} alt="app icon" />
                                </div>
                                <span>Download Our Free App</span>
                                <img src={slantarrow} alt="arrow" className="downloadpage-item-arrow" />
                            </a>
                            <a href="https://www.hayatinapp.com/vendor/register" className="downloadpage-interactive-item">
                                <div className="downloadpage-item-icon blue">
                                    <img src={hayatbusiness} alt="app icon" />
                                </div>
                                <span>Register your business</span>
                                <img src={slantarrow} alt="arrow" className="downloadpage-item-arrow" />
                            </a>
                            <a
                                href="https://website.hayatinapp.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="downloadpage-interactive-item"
                            >
                                <div className="downloadpage-item-icon pink">
                                    <img src={explive} alt="app icon" />
                                </div>
                                <span>Experience the App Live</span>
                                <img src={slantarrow} alt="arrow" className="downloadpage-item-arrow" />
                            </a>
                            <div 
                                className="downloadpage-interactive-item"
                                onClick={() => {
                                    setActiveTab("Shop");
                                    setSelectedSection("grandMillennium");
                                }}
                            >
                                <div className="downloadpage-item-icon gray">
                                    <img src={grandm} alt="app icon" />
                                </div>
                                <span>Grand Millennium Al Wahda</span>
                                <img src={slantarrow} alt="arrow" className="downloadpage-item-arrow" />
                            </div>
                            <div 
                                className="downloadpage-interactive-item"
                                onClick={() => {
                                    setActiveTab("Shop");
                                    setSelectedSection("ramadanSpecials");
                                }}
                            >
                                <div className="downloadpage-item-icon gray">
                                    <img src={ramadan} alt="app icon" />
                                </div>
                                <span>Ramadan Specials</span>
                                <img src={slantarrow} alt="arrow" className="downloadpage-item-arrow" />
                            </div>

                            {/* Bottom Section */}
                            <div className="downloadpage-bottom-section">
                                <h3 className="downloadpage-bottom-title">Download Our App</h3>
                                <div className="downloadpage-bottom-content">
                                    <div className="downloadpage-qr-section">
                                        <img src={qr} alt="QR Code" className="downloadpage-qr" />
                                    </div>
                                    <div className="downloadpage-store-buttons-bottom">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="Download on the App Store" />
                                        </a>
                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Get it on Google Play" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="downloadpage-shop-content">
                            {/* Grand Millennium Section */}
                            {(selectedSection === null || selectedSection === "grandMillennium") && (
                                <>
                                    <h2 className="downloadpage-shop-title">Grand Millennium Al Wahda</h2>

                                    {/* Top Offers Section */}
                                    <div className="downloadpage-top-offers">
                                        <div className="downloadpage-offer-card">
                                            <div className="downloadpage-offer-image">
                                                <img src={goffer1} alt="Winter Staycation" />
                                            </div>
                                            <div className="downloadpage-offer-content">
                                                <h3 className="downloadpage-offer-title">Hala Winter Staycation - Exclusive Seasonal Rates</h3>
                                                <div className="downloadpage-offer-price">
                                                    <span className="downloadpage-old-price">AED 99</span>
                                                    <span className="downloadpage-new-price">AED 69.3</span>
                                                    <span className="downloadpage-separator">|</span>
                                                    <span className="downloadpage-discount">30% OFF</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="downloadpage-offer-card">
                                            <div className="downloadpage-offer-image">
                                                <img src={goffer2} alt="Massage Treatments" />
                                            </div>
                                            <div className="downloadpage-offer-content">
                                                <h3 className="downloadpage-offer-title">30% Off Massage Treatments</h3>
                                                <div className="downloadpage-offer-price">
                                                    <span className="downloadpage-discount-tag">30% OFF</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Ramadan Iftar & Suhoor Section */}
                                    <div className="downloadpage-ramadan-main-card">
                                        <div className="downloadpage-offer-image-large">
                                            <img src={goffer3} alt="Ramadan Iftar & Suhoor" />
                                        </div>
                                        <div className="downloadpage-offer-content">
                                            <h3 className="downloadpage-offer-title">Ramadan Iftar & Suhoor Under the Stars</h3>
                                            <div className="downloadpage-offer-price">
                                                <span className="downloadpage-from-price">From AED 125</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Ramadan Specials Section */}
                            {(selectedSection === null || selectedSection === "ramadanSpecials") && (
                                <>
                                    <h2 className="downloadpage-shop-title">Ramadan Specials</h2>

                                    {/* Top Offers Section */}
                                    <div className="downloadpage-top-offers">
                                        <div className="downloadpage-offer-card">
                                            <div className="downloadpage-offer-image">
                                                <img src={roffer1} alt="Winter Staycation" />
                                            </div>
                                            <div className="downloadpage-offer-content">
                                                <div className="downloadpage-hotel-info">
                                                    <img src={businessicon} alt="hotel" className="downloadpage-hotel-icon" />
                                                    <span>Al Mizah-Royal M Hotel</span>
                                                </div>
                                                <h3 className="downloadpage-offer-title">Ramadan Iftar Buffet</h3>
                                                <div className="downloadpage-offer-price">
                                                    <span className="downloadpage-from-price">From AED 185</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="downloadpage-offer-card">
                                            <div className="downloadpage-offer-image">
                                                <img src={roffer2} alt="Massage Treatments" />
                                            </div>
                                            <div className="downloadpage-offer-content">
                                                <div className="downloadpage-hotel-info">
                                                    <img src={businessicon} alt="hotel" className="downloadpage-hotel-icon" />
                                                    <span>Al Mizah-Royal M Hotel</span>
                                                </div>
                                                <h3 className="downloadpage-offer-title">Ramadan Suhoor at Al Mizah</h3>
                                                <div className="downloadpage-offer-price">
                                                    <span className="downloadpage-from-price">From AED 116</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Ramadan Iftar & Suhoor Section */}
                                    <div className="downloadpage-ramadan-main-card">
                                        <div className="downloadpage-offer-image-large">
                                            <img src={roffer3} alt="Ramadan Iftar & Suhoor" />
                                        </div>
                                        <div className="downloadpage-offer-content">
                                            <div className="downloadpage-hotel-info">
                                                <img src={businessicon} alt="hotel" className="downloadpage-hotel-icon" />
                                                <span>Al Mizah-Royal M Hotel</span>
                                            </div>
                                            <h3 className="downloadpage-offer-title">Eid Al Fitr Grand Lunch</h3>
                                            <div className="downloadpage-offer-price">
                                                <span className="downloadpage-from-price">From AED 225</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}


                </div>
            </div>
        </>
    );
}

export default DownloadPage